import { fit } from '@/editions/fit';
import { soccer } from '@/editions/soccer';
import type { EditionDefinition, EditionId } from '@/editions/types';
import { useMe } from '@/features/me/MeContext';

export type { EditionDefinition, EditionId, Item, Section } from '@/editions/types';

/** A user without an `edition` field on `/me` (the API default) is Fit. */
export const DEFAULT_EDITION: EditionId = 'fit';

const EDITIONS: Record<EditionId, EditionDefinition> = { fit, soccer };

export function getEdition(id: EditionId | undefined | null): EditionDefinition {
  return EDITIONS[id ?? DEFAULT_EDITION] ?? EDITIONS[DEFAULT_EDITION];
}

/** The caller's edition, read from `MeContext`. Never invents one — `/me` is the source. */
export function useEdition(): EditionDefinition {
  const { me } = useMe();
  return getEdition(me.user?.edition);
}
